// extracted by mini-css-extract-plugin
module.exports = {"root":"PatternAutocomplete_root__3B5lR","list":"PatternAutocomplete_list__3eeEk"};